import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("jwt-auth")}`,
  },
});

export const getAllReports = async (data) => {
  try {
    const res = await api.post("/report/all", data);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getReportDetails = async () => {
  try {
    const res = await api.get("/report/all");
    return res;
  } catch (err) {
    return err.response;
  }
};

export const updateReportStatus = async () => {
  try {
    const res = await api.get("/report/all");
    return res;
  } catch (err) {
    return err.response;
  }
};
